








































































































































































































import VueOptions from '@utils/VueOptions'
import ResourceBindSelector from '@ui/ResourceBindSelector/ResourceBindSelector'
import LoadingIndicator from '@/components/LoadingIndicator'
import Modal from '@/components/Modal'
import CalendarService from '@services/CalendarService'

settings =
  name: 'SamplingSpaceAvailabilityBindSelector'

  resources:
    space_resource:
      resourceName: 'space'
      slug: 'suppliers/:supplierId/spaces/:space.id/edit'
      fetch: false

    availabilities:
      resourceName: 'audience_availability'
      slug: 'suppliers/:supplierId/audience_availabilities'
      fetch: false

  vue:
    props: ['space', 'options']

    components: {
      ResourceBindSelector,
      LoadingIndicator,
      Modal,
    }

    data: ->
      selectedSpaceAvailabilities: []
      selectedAvailabilities: []
      advancedSettings: []
      simulatorQuantity: null

      capacityModal:
        show: false
        availabilities: []
        segment: null
        dayOptions: []
        minDuration: null
        maxDuration: null
        engagementCapacity: null

    mounted: ->
      @fetchAvailabilities()

    computed:
      simulatorCollapse:
        get: -> if @simulatorQuantity then '1' else ''
        set: ->

      creativeId: -> @$route.params.audienceCreativeId
      supplierId: -> @options?.supplierId || @$store.member.supplier.id
      spaceAvailabilityIds: -> @space.availability_ids || []
      spaceAvailabilities: ->
        items = []
        for availability in (@availabilities || [])
          items.push availability if availability.id in @spaceAvailabilityIds
        items

      segmentRenamed: -> @space.segment_renamed || @space.syncing_segments

      spaceAvailabilitiesTableData: ->
        for availability in @spaceAvailabilities
          id: availability.id
          data: availability
          experience: availability.title
          location: @$options.filters.formatLocation(availability)
          street: availability.venue_street
          venue: availability.venue_name

      availabilitiesTableData: ->
        for availability in @availabilities
          continue if availability.id in @spaceAvailabilityIds
          id: availability.id
          data: availability
          experience: availability.title
          location: @$options.filters.formatLocation(availability)
          street: availability.venue_street
          venue: availability.venue_name

      canSaveCapacityModal: ->
        return false unless @capacityModal.engagementCapacity?[@capacityModal.segment]
        { sampling_capacity } = @capacityModal.engagementCapacity?[@capacityModal.segment]
        return true if sampling_capacity.default.daily
        values = Object.values(sampling_capacity.daily)
        !values.some((v) => !v)

      optionsForBindSelector: ->
        required: true
        title: 'Hosted at these Venues'
        # description: 'Select the venues that have this segment available to sponsors'
        addButtonText: 'Setup Venue'
        addExistingButtonText: 'Add Existing Venue'
        why: 'You can setup more venues to host this opportunity.' if @availabilitiesTableData.length

      simulatorTableData: ->
        [
          {
            enabled: true
            label: 'Hand out a Beverage'
            payout: @spacePayoutForPricingTable(['drink_distribution'])
            unitPayout: @unitPayoutForPricingTable(['drink_distribution'])
          },
          {
            enabled: @space.services.can_serve_cold
            label: 'Hand out a Cold Beverage'
            tooltip: 'This service is not enabled, you can go back to enable it' unless @space.services.can_serve_cold
            payout: @spacePayoutForPricingTable(['drink_distribution', 'addon_serve_cold'])
            unitPayout: @unitPayoutForPricingTable(['drink_distribution', 'addon_serve_cold'])
          },
          {
            enabled: true
            label: 'Hand out a Snack'
            payout: @spacePayoutForPricingTable(['food_distribution'])
            unitPayout: @unitPayoutForPricingTable(['food_distribution'])
          },
          {
            enabled: @space.services.can_assemble_items
            label: 'Assemble a Package w/ Food & Promo'
            tooltip: 'This service is not enabled, you can go back to enable it' unless @space.services.can_assemble_items
            payout: @spacePayoutForPricingTable(['food_distribution', 'addon_promo_distribution', 'addon_assembly'])
            unitPayout: @unitPayoutForPricingTable(['food_distribution', 'addon_promo_distribution', 'addon_assembly'])
          },
          {
            enabled: true
            label: 'Hand out other CPG'
            tooltip: 'Consumer packaged goods like beauty products or personal care'
            payout: @spacePayoutForPricingTable(['other_cpg_distribution'])
            unitPayout: @unitPayoutForPricingTable(['other_cpg_distribution'])
          },
        ]

    methods:
      hiSpaceAvailabilitiesSelectionChange: (availabilities) ->
        @selectedSpaceAvailabilities = availabilities
      hiSpaceAvailabilitiesRowClick: (row) ->
        @$refs.spaceAvailabilitiesTable.toggleRowSelection row
      hiUnbindSpaceAvailability: (availability) ->
        @unbindAvailabilitiesFromSpaceTrigger [availability]
      hiUnbindSelectedSpaceAvailabilities: ->
        @unbindAvailabilitiesFromSpaceTrigger @selectedSpaceAvailabilities

      hiAvailabilitiesSelectionChange: (availabilities) ->
        @selectedAvailabilities = availabilities
      hiAvailabilitiesRowClick: (row) ->
        @$refs.availabilitiesTable.toggleRowSelection row
      hiBindAvailability: (availability) ->
        @bindAvailabilitiesToSpaceTrigger [availability]
      hiBindSelectedAvailabilities: ->
        @$refs.bindSelector.close()
        @bindAvailabilitiesToSpaceTrigger @selectedAvailabilities

      hiCloseCapacityModal: ->
        @closeCapacityModal()

      hiToggleAdvancedSettings: ->
        if '1' in @advancedSettings
          @advancedSettings = []
        else
          @advancedSettings = ['1']

      hiSaveCapacityModal: ->
        { availabilities, engagementCapacity, minDuration, maxDuration } = @capacityModal
        @capacityModal.engagementCapacity[@capacityModal.segment].sampling_capacity.min_duration = minDuration
        @capacityModal.engagementCapacity[@capacityModal.segment].sampling_capacity.max_duration = maxDuration
        delete @capacityModal.engagementCapacity[@capacityModal.segment].minimum_purchase_in_cents if minDuration || maxDuration
        @setCapacityTrigger availabilities, engagementCapacity
        @closeCapacityModal()

      hiSetCapacity: ->
        @hiEditCapacity @selectedSpaceAvailabilities.map((a) => a.data)

      hiEditCapacity: (availabilities) ->
        { segment } = @space
        availability = availabilities[0]

        dayOptions = CalendarService.dayOptionsForEvents availability.dates
        engagementCapacity = JSON.parse(JSON.stringify(availability.engagement_capacity))
        engagementCapacity[segment] ||= {}
        engagementCapacity[segment].agree_to_pricing = availability.engagement_capacity[segment]?.agree_to_pricing
        engagementCapacity[segment].agree_to_pricing = true unless availability.engagement_capacity[segment]?.agree_to_pricing?
        engagementCapacity[segment].sampling_capacity ||= {}
        engagementCapacity[segment].sampling_capacity.daily ||= {}
        engagementCapacity[segment].sampling_capacity.daily[option.value] = availability.engagement_capacity[segment]?.sampling_capacity?.daily?[option.value] for option in dayOptions
        engagementCapacity[segment].sampling_capacity.default ||= {}
        engagementCapacity[segment].sampling_capacity.default.daily ||= availability.engagement_capacity[segment]?.sampling_capacity?.default?.daily
        minDuration = engagementCapacity[segment].sampling_capacity.min_duration
        maxDuration = engagementCapacity[segment].sampling_capacity.max_duration

        @simulatorQuantity = engagementCapacity[segment].sampling_capacity.default.daily
        @advancedSettings = []
        @advancedSettings = ['1'] unless @isEmptyValue engagementCapacity[segment].sampling_capacity.daily
        @capacityModal =
          show: true
          availabilities: availabilities
          segment: segment
          dayOptions: dayOptions
          minDuration: minDuration
          maxDuration: maxDuration
          engagementCapacity: engagementCapacity

      hiChangeDailyCapacity: (value, day) ->
        v = parseInt value.replace(/,/g, '')
        v = undefined if isNaN v
        @capacityModal.engagementCapacity[@capacityModal.segment].sampling_capacity.daily[day] = v

      hiChangeDefaultDailyCapacity: (value) ->
        v = parseInt value.replace(/,/g, '')
        v = undefined if isNaN v
        @simulatorQuantity = v
        @capacityModal.engagementCapacity[@capacityModal.segment].sampling_capacity.default.daily = v

      closeCapacityModal: ->
        @capacityModal =
          show: false
          data: null

      availabilityHasSamplingCapacity: (availability) ->
        !@isEmptyValue availability.engagement_capacity?[@space.segment]?.sampling_capacity

      formatCapacityModalDescription: ->
        availability = @capacityModal.availabilities[0]
        location = @$options.filters.formatLocation availability
        address = [availability.venue_name, location]
        @compact(address).join(', ')

      formatCapacity: (availability) ->
        { sampling_capacity } = availability.engagement_capacity[@space.segment]
        values = []
        values.push ...Object.values(sampling_capacity.daily || {})
        values.push ...Object.values(sampling_capacity.default || {})
        values = @compact(new Float64Array(new Set(values)))
        values.sort()
        return '' unless values.length
        return values[0] unless values.length > 1
        "#{values[0]} - #{values[values.length - 1]}"

      bindAvailabilitiesToSpaceTrigger: (availabilities) ->
        @$emit 'bind'
        for chunk in @chunkArray(availabilities, 500)
          payload =
            availability_ids: chunk.map((a) => a.id)
          @triggerResource 'space_resource', 'bind_availabilities', payload
      onSpaceResourceBindAvailabilities: (_, item) ->
        @$emit 'change', item

      unbindAvailabilitiesFromSpaceTrigger: (availabilities) ->
        @$emit 'unbind'
        for chunk in @chunkArray(availabilities, 500)
          payload = { availability_ids: chunk.map((a) => a.id) }
          @triggerResource 'space_resource', 'unbind_availabilities', payload
      onSpaceResourceUnbindAvailabilities: (payload, item) ->
        @$emit 'unbindAll' if payload.availability_ids.length is @spaceAvailabilityIds.length
        @$refs.spaceAvailabilitiesTable?.clearSelection()
        @$emit 'change', item

      setCapacityTrigger: (availabilities, capacity) ->
        payload = { availability_ids: availabilities.map((a) => a.id), capacity }
        @triggerResource 'availabilities', 'set_capacity', payload
      onAvailabilitiesSetCapacity: (_, item) ->
        @fetchAvailabilities()
        @$emit 'change', item

      fetchAvailabilities: ->
        params = { quick_list: true }
        params.audience_creative_id = @creativeId if @creativeId
        @fetch 'availabilities', params

      spacePayoutForPricingTable: (pricingModels) ->
        payoutInCents = 0.0
        for pricingModel in pricingModels
          availability = @capacityModal.availabilities[0]
          pricing = availability.pricing_table[pricingModel]

          if pricing.take_percentage
            takeInCents = (pricing.price_in_cents / 100) * pricing.take_percentage
          else
            takeInCents = pricing.take_in_cents

          payoutInCents += (pricing.price_in_cents - takeInCents) * parseInt(@simulatorQuantity || 0)
        payoutInCents / 100

      unitPayoutForPricingTable: (pricingModels) ->
        payoutInCents = 0.0
        for pricingModel in pricingModels
          availability = @capacityModal.availabilities[0]
          pricing = availability.pricing_table[pricingModel]

          if pricing.take_percentage
            takeInCents = (pricing.price_in_cents / 100) * pricing.take_percentage
          else
            takeInCents = pricing.take_in_cents

          payoutInCents += (pricing.price_in_cents - takeInCents)
        payoutInCents / 100

export default VueOptions.vue settings
